export default "__VITE_ASSET__0X918QG$__ 320w, __VITE_ASSET__CVBDs0TM__ 480w, __VITE_ASSET__RpZV7U2c__ 640w, __VITE_ASSET__CdSwz26m__ 800w";